<template>
    <div class="body">
        <div class="input-card">
            <div class="title">
                <img src="../assets/title.png" >
            </div>
            <el-select
                    v-model="nameShow"
                    filterable
                    remote
                    no-data-text = "省|市|县|地区代码"
                    placeholder="省|市|县|地区代码"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    class="input1"
                    @change="search">
                <el-option
                        v-for="item in optionLen"
                        :key="item "
                        :label="options[item-1]"
                        :value="options[item-1]" class="option" >
                </el-option>
            </el-select>
            <div class="info-panel" >
                <div class="info-list" >
                    <div class="info-block">
                        <div class="info-block-key">地名: </div>
                        <div class="info-block-value">{{cityName}}</div>
                        <div class="info-block-unit"></div>
                    </div>
                    <div class="info-block">
                        <div class="info-block-key">adcode: </div>
                        <div class="info-block-value">{{cityId}}</div>
                        <div class="info-block-unit"></div>
                    </div>
                    <div class="info-block">
                        <div class="info-block-key">JSON API</div>
                        <div class="info-block-value">
                            <pre >{{ jsonUrl }}</pre>
                        </div>
                        <div class="info-block-key" v-if="jsonFlag">JSON API(包含子区域)</div>
                        <div class="info-block-value" v-if="jsonFlag">
                          <pre >{{ jsonFullUrl }}</pre>
                        </div>
                    </div>
                </div>
                <div class="info-download">
                  <br>
                  <label class="info-input">
                    <input name="checkbox" type="checkbox" checked="checked" v-model="checkbox">包含子区域
                  </label>
                  <br>
                  <div class="info-download-list">
                    <br>
                      <input id="foo" :value="codeShow" >
                      <div style="display: inline-block;margin-left: 10px;position: absolute;">
                          <button class="btn"   >
                              <img class="clippy" src="@/assets/download.svg" data-clipboard-target="#foo"
                                   @click="copy">
                          </button>
                      </div>
                    <div class="download-list">
                      <div class="info-block-key">geojson:</div>
                      <a class="info-block-value" :href="downloadUrl" :download="cityName" style="padding-top: 10px">
                          <img src="../assets/down.png">
                      </a>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from "axios";

    export default {
        name: "MapRange",
        props:{
          cityId:{
            type: String,
            define:{}
          },
          cityName: {
            type: String,
            define:{}
          },
          cityMap: {
            type: Array
          }
        },

        data() {
              return {
                options: [],
                nameShow: this.cityName,
                cityList: [],
                loading: false,
                states: [],
                jsonUrl: "https://uniplore-source.oss-cn-chengdu.aliyuncs.com/bigscreen/bound/100000.json",
                jsonFullUrl: "https://uniplore-source.oss-cn-chengdu.aliyuncs.com/bigscreen/bound/100000_full.json",
                jsonFlag: true,
                checkbox: true,
                codeShow: null,
                downloadUrl: '/json/map/100000_full.json',
                checkboxFlag: true,
                optionLen: 0
              }
          },
        watch: {
          cityName:{
            handler:function(val){
              this.nameShow = val
            },
            deep:true//对象内部的属性监听，也叫深度监听
          },
          cityId:{
            handler:function(val){
                val = val.toString()
              this.jsonUrl = "https://uniplore-source.oss-cn-chengdu.aliyuncs.com/bigscreen/bound/" + val + ".json"
              this.jsonFullUrl = "https://uniplore-source.oss-cn-chengdu.aliyuncs.com/bigscreen/bound/" + val + "_full.json"
              this.jsonFlag = (val.slice(2, 6) === "0000" || val.slice(4, 6) === "00")
              this.download(this.jsonFlag,this.checkboxFlag,val)
              this.getJson(val,this.jsonFlag)
            },
            deep:true//对象内部的属性监听，也叫深度监听
          },
          checkbox:function (val) {
            this.$emit('getCheckbox', val);
            this.checkboxFlag = val
            this.download(this.jsonFlag,this.checkboxFlag,this.cityId)
          }
        },
        created() {
            this.getJson('100000',true)
            var gb2260 = require('gb2260');
            gb2260.register('201607', require('gb2260/lib/201607'))
            var gb = new gb2260.GB2260('201607');
            var code = ''
            axios.get('/json/map/adcode-map.json').then(response => {
                var cityJson = response
                for (let i = 0; i < cityJson.data.length; i++) {
                    var division = gb.get(cityJson.data[i]["adcode"])
                    if (division === null) {
                        this.states.push(cityJson.data[i].name + "(" + cityJson.data[i]["adcode"] + ")")
                        this.cityList.push(this.states[i].slice(0, -8))
                        continue
                    }else if (division.province == null) {
                        code = "100000"
                    }else if (division.prefecture == null){
                        code = gb.get(cityJson.data[i]["adcode"]).province.code
                    }else {
                        code = gb.get(cityJson.data[i]["adcode"]).prefecture.code
                    }
                    this.states.push( code + "|" + cityJson.data[i].name + "(" + cityJson.data[i]["adcode"] + ")")
                    this.cityList.push(this.states[i].slice(0, -8))
                }
            })
          },
        mounted() {
          this.list = this.states.map(item => {
              var str = item.slice(0,-8)
              return { value: `${str}`, label: `${item}` };
          });
          this.cityId.slice(2, 6) !== "0000" || this.cityId.slice(4, 6) !== "00" ? this.jsonFlag = false : ''
        },
        computed: {
        },
        methods: {
            copy() {
                var clipboard = new this.clipboard('.clippy');
                clipboard.on('success', function() {
                });
                clipboard.on('error', function() {
                });
            },

              download (jsonFlag,checkboxFlag,val) {
                  if (jsonFlag && checkboxFlag) {
                      this.downloadUrl= '/json/map/' + val + '_full.json'
                  }else{
                      this.downloadUrl = '/json/map/' + val + '.json'
                  }
              },
              getJson(val,flag){
                var code = ''
                if (this.checkbox  && flag) {
                  code = val + "_full"
                }else {
                  code = val
                }

                axios.get('/json/map/' + code + '.json').then(response => {
                  this.codeShow = JSON.stringify(response.data)

                })
              },
              search(area) {
                if (area !== null) {
                  area = area.slice(-7, -1)
                  this.$emit('search', area);
                }
              },
              remoteMethod(query) {
                  if (query !== '') {
                      this.options = []
                      for (let i = 0; i <this.states.length; i++) {
                          if(this.states[i].toLowerCase()
                              .indexOf(query.toLowerCase()) > -1){
                              this.options.push(this.states[i])
                          }
                      }
                      this.optionLen = this.options.length > 5 ? 5 :this.options.length
                  } else {
                      this.options = [];
                  }
              }
          }
      }
</script>

<style scoped>
    html, body {
        width: 100%;
        height: 100vh;
    }


    .body {
        height: 100vh;
    }

    .input-card {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 900px;
    }

    .title {
        margin-left: 64px;
        margin-top: 50px;
    }
    .info-panel{
        position: absolute;
        top: 350px;
        left: 60px;
        width: 400px;
    }
    .info-list, .download-list, .info-download, .info-download-list{
      width: 100%;
      height: auto;
      padding: 0px 0px;
      display: inline-block;
    }
    .info-download-list input {
      max-width: 80%;
      position: relative;
      width: 100%;
      height: 30px;
      line-height: 30px;
      display: table-cell;
    }
    .input1 {
        position: absolute;
        left: 70px;
        top: 100px;

    }
    /deep/.el-input__inner{
        height: 30px;
        width: 300px;
        }
    .info-block {
        width: auto;
        height: 30px;
        padding: 0 10px;
        line-height: 30px;
        display: inline-block;
    }
    .info-block-key, .info-block-unit{
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        color: #666;
        padding: 8px;
        font-weight: normal;
    }
    .info-block-value {
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        color: #000;
        font-weight: bold;
    }
    .el-select-dropdown{
      max-width: 40%;
    }
    .el-select-dropdown__item{
      overflow: visible;
    }
    pre{
      display: block;
      padding: 9.5px;
      margin: 0 0 10px;
      font-size: 13px;
      line-height: 1.42857143;
      color: #333333;
      word-break: break-all;
      word-wrap: break-word;
      background-color: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
    .clippy {
        height: 27px;
    }
    .info-input{
      display: inline-block;
      font-size: 12px;
    }
    label{
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: 700;
    }
    .option:hover{
        font-weight: bold;
    }
    .option{
        list-style-type:none;
        border: solid 2px #e8e8e8;
        padding: 8px;
        width: 290px;
    }
</style>
